import firebase from '@/plugins/firebase'
import APIUser from '@/API/APIUser'
import APIPartyRoom from '@/API/APIPartyRoom'
import APISpotify from '@/API/APISpotify'

export default class APIClient {
  public static User = APIUser
  public static PartyRoom = APIPartyRoom
  public static Spotify = APISpotify
}
